import React from 'react'
import { Outlet } from 'react-router-dom'

function MainAvailability() {
  return (
   <div>
      <Outlet/>
    </div>
  )
}

export default MainAvailability